import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const list = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	border-radius: 5px;
	padding: 1.5rem;
	background-color: ${color.interface.white};
`;

export const itemTag = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem;
	border-radius: 5px;
	border: 1px solid ${color.interface.lightGray2};
`;

export const boxInfos = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	> svg,
	img {
		width: 90px;
		height: 90px;
		object-fit: fill;
		border-radius: 5px;
		padding: 10px 0px 10px 10px;
		color: ${color.interface.lightGray};
	}
`;

export const infos = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;

	> p {
		font-family: nunito-light;
		font-size: 1.3rem;
	}
`;

export const controls = styled.div`
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 2.5rem;
		color: ${color.interface.lightGray};
	}
`;

export const colorTag = styled.div<{ $color: string }>`
	position: absolute;
	left: 0;
	height: 100%;
	min-width: 10px;
	background-color: ${(props) => props.$color};
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;

	-webkit-box-shadow: 2px 0px 8px -4px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 2px 0px 8px -4px rgba(0, 0, 0, 0.75);
	box-shadow: 2px 0px 8px -4px rgba(0, 0, 0, 0.75);
`;

export const noTag = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> p {
		color: ${color.interface.darkgray};
		font-size: 1.5rem;
	}
`;

export const centralizeLoad = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	padding: 1.5rem;
	background-color: ${color.interface.white};
`;
